var React = require('react');

function Zoom (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},".st0{fill:#0f482a}"),React.createElement("path",{"d":"M19.7 18.3l-5.4-5.4C15.4 11.5 16 9.8 16 8c0-4.4-3.6-8-8-8S0 3.6 0 8s3.6 8 8 8c1.8 0 3.5-.6 4.9-1.7l5.4 5.4c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4zM2 8c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6-6-2.7-6-6z","key":1}),React.createElement("path",{"d":"M11 7H9V5c0-.6-.4-1-1-1s-1 .4-1 1v2H5c-.6 0-1 .4-1 1s.4 1 1 1h2v2c0 .6.4 1 1 1s1-.4 1-1V9h2c.6 0 1-.4 1-1s-.4-1-1-1z","key":2})]);
}

Zoom.defaultProps = {"version":"1.1","x":"0","y":"0","width":"20","height":"20","viewBox":"0 0 20 20","xmlSpace":"preserve"};

module.exports = Zoom;

Zoom.default = Zoom;
